import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[libCurrencyPrefix]'
})
export class CurrencyPrefixDirective implements OnInit {

  private readonly prefix = '$';

  constructor(private el: ElementRef, private control: NgControl) { }

  ngOnInit(): void {
    const value = this.el.nativeElement.value;

    if (!value) {
      this.el.nativeElement.value = this.prefix;
      return;
    }

    if (value.startsWith(this.prefix)) {
      return;
    }

    this.el.nativeElement.value = `${this.prefix}${value}`;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/[^0-9]/g, '');

    const formattedValue = value ? `${this.prefix}${value}` : this.prefix;
    
    this.control.control?.setValue(formattedValue, { emitEvent: false });
  }
}
